import { MonoTypeOperatorFunction, tap } from 'rxjs';

/**
 * Perform side-effects for an error notification
 *
 * @param tapFn side-effect to perforn on error
 */
export function tapError<T>(tapFn: (err: any) => void): MonoTypeOperatorFunction<T> {
    return (source$) => source$.pipe(tap<T>({ error: tapFn }));
}
